function initNewLandingVideoSection(root) {
  var scope = root && root.querySelectorAll ? root : document;

  scope.querySelectorAll('.new-landing-video-section').forEach(function (section) {
    if (section.dataset.videoSectionInitialized) return;
    section.dataset.videoSectionInitialized = 'true';

    var modal = section.querySelector('[data-video-modal]');
    if (!modal) return;

    var iframe = modal.querySelector('[data-video-modal-iframe]');

    function openModal(videoId) {
      iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&modestbranding=1';
      modal.hidden = false;
      document.body.classList.add('new-landing-video-modal-open');
    }

    function closeModal() {
      modal.hidden = true;
      iframe.src = '';
      document.body.classList.remove('new-landing-video-modal-open');
    }

    section.querySelectorAll('[data-video-thumbnail]').forEach(function (button) {
      button.addEventListener('click', function () {
        openModal(button.getAttribute('data-video-id'));
      });
    });

    modal.querySelectorAll('[data-video-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  });
}

function initNewLandingVideoPopupToggle() {
  if (window.__newLandingVideoPopupToggleBound) return;
  window.__newLandingVideoPopupToggleBound = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-video-popup-toggle]');
    if (!trigger) return;

    var section = document.querySelector('.new-landing-video-section');
    var modal = section ? section.querySelector('[data-video-modal]') : null;
    if (!modal) return;

    event.preventDefault();

    var iframe = modal.querySelector('[data-video-modal-iframe]');

    if (modal.hidden) {
      var thumbnail = section.querySelector('[data-video-thumbnail]');
      var videoId = thumbnail ? thumbnail.getAttribute('data-video-id') : '';
      if (!videoId) return;
      iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&modestbranding=1';
      modal.hidden = false;
      document.body.classList.add('new-landing-video-modal-open');
    } else {
      modal.hidden = true;
      iframe.src = '';
      document.body.classList.remove('new-landing-video-modal-open');
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initNewLandingVideoSection(document);
  initNewLandingVideoPopupToggle();
});

document.addEventListener('shopify:section:load', function (event) {
  initNewLandingVideoSection(event.target);
  initNewLandingVideoPopupToggle();
});

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initNewLandingVideoSection(document);
  initNewLandingVideoPopupToggle();
}
